import { MonitorSubscriberNotificationLevel } from "./monitorDetailsInformation/MonitorSubscriberNotificationLevel";
import { ClientWorkflow } from "@avenueops/shared-types";
import { Badge } from "@avenueops/web-components";

interface Props {
  workflow: ClientWorkflow;
}

export function MonitorDetailsSubscriberSection({ workflow }: Props) {
  return (
    <div className="grid grid-cols-10 gap-2 w-full">
      {workflow.notificationLevels && workflow.notificationLevels.length > 0 && workflow.notificationLevels[0].recipients.length > 0 ? (
        workflow.notificationLevels.map((notificationLevel, index) => {
          return (
            <MonitorSubscriberNotificationLevel
              key={index}
              notificationLevel={notificationLevel}
              notificationIndex={index}
              hasDefaultOnly={workflow.notificationLevels.length < 2}
            />
          );
        })
      ) : (
        <Badge type="CUSTOM" className="bg-white">
          None
        </Badge>
      )}
    </div>
  );
}
